import React from 'react';

import { ASSET_TYPES } from '@/shared/api/openmetadata';
import { Icon } from '@/shared/ui/Icon';

import type { SearchResultType } from '@/entities/search';

const DEFAULT_TAB_MAP: Record<string, string> = {
  [ASSET_TYPES.TABLE]: 'columns',
  [ASSET_TYPES.CONTAINER]: 'lineage',
  [ASSET_TYPES.DATABASE]: 'schemas',
  [ASSET_TYPES.DATABASE_SCHEMA]: 'tables',
  [ASSET_TYPES.SERVICE]: 'insights',
  [ASSET_TYPES.GLOSSARY_TERM]: 'glossary_terms',
  [ASSET_TYPES.MLMODEL]: 'versions',
};

export const getDefaultTabByAssetType = (type: string): string => {
  return DEFAULT_TAB_MAP[type] || '';
};

export const getAssetTypeIcon = (type: string, className?: string, size?: number, color?: string): React.ReactNode => {
  return <Icon assetType={type} className={className} size={size || 16} color={color} />;
};

export const getIconForEntityType = (type: SearchResultType): React.ReactNode => {
  switch (type) {
    case 'dataset':
    case 'database':
    case 'databaseSchema':
      return <Icon name="database" />;
    case 'table':
      return <Icon name="table" />;
    case 'file':
    case 'container':
      return <Icon name="file" />;
    case 'dashboard':
      return <Icon name="dashboard" />;
    case 'pipeline':
      return <Icon name="pipeline" />;
    case 'topic':
      return <Icon name="folder" />;
    case 'glossaryTerm':
    case 'tag':
      return <Icon name="tag" />;
    case 'mlmodel':
      return <Icon name="cloud" />;
    case 'experiment':
      return <Icon name="experiment" />;
    case 'run':
      return <Icon name="experiment" />;
    default:
      return <Icon name="hard-drive" />;
  }
};
